/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ViewType {
  System = 'System',
  Personal = 'Personal'
}
